// context/FilterContext.js
import { createContext, useState, useContext } from "react";

// Create the context
const FilterContext = createContext();

// Create a provider component
export const FilterProvider = ({ children }) => {
    const [saveAppliedFilter, setSaveAppliedFilter] = useState(false);
    const [removeAppliedFilter, setRemoveAppliedFilter] = useState(false);
    const [isFilterToogleOn, setIsFilterToogleOn] = useState(false);

    return (
        <FilterContext.Provider
            value={{
                saveAppliedFilter,
                setSaveAppliedFilter,
                removeAppliedFilter,
                setRemoveAppliedFilter,
                isFilterToogleOn,
                setIsFilterToogleOn
            }}>
            {children}
        </FilterContext.Provider>
    );
};

// Custom hook to use the context
export const useFilterContext = () => useContext(FilterContext);
